import { NormalSelectOptions } from "@app/components/select/select.type";

export enum DeviceStatus {
  ACTIVE = "active",
  IN_ACTIVE = "in_active",
}

export enum DeviceType {
  DOWNLOAD = "download",
  CALL = "call",
  ANSWER = "answer",
}

export const DeviceTypeLabel = {
  [DeviceType.DOWNLOAD]: "Download",
  [DeviceType.CALL]: "Call",
  [DeviceType.ANSWER]: "Answer",
};

export const FilterStatusDeviceOptions: NormalSelectOptions = [
  {
    label: "Tất cả",
    value: "",
  },
  {
    label: DeviceStatus.ACTIVE,
    value: DeviceStatus.ACTIVE,
  },
  {
    label: DeviceStatus.IN_ACTIVE,
    value: DeviceStatus.IN_ACTIVE,
  },
];

export const FilterTypeDeviceOptions: NormalSelectOptions = [
  {
    label: "Tất cả",
    value: "",
  },
  {
    label: DeviceType.DOWNLOAD,
    value: DeviceType.DOWNLOAD,
  },
  {
    label: DeviceType.CALL,
    value: DeviceType.CALL,
  },
  {
    label: DeviceType.ANSWER,
    value: DeviceType.ANSWER,
  },
];
